type InstagramPublicationSummary = {
  status?: string | null;
  publishNowRequestedAt?: string | null;
};

type ScheduledPostWithInstagramPublication = {
  id: string;
  publication?: InstagramPublicationSummary | null;
};

export const isInstagramPublicationPending = (
  publication: InstagramPublicationSummary | null | undefined,
): boolean =>
  publication?.status === "publishing" ||
  (publication?.status === "ready_for_publish" && Boolean(publication.publishNowRequestedAt));

export const hasActiveInstagramPublishNow = (
  scheduledPosts: ScheduledPostWithInstagramPublication[] | undefined,
  scheduledPostId?: string,
): boolean =>
  Boolean(
    scheduledPosts?.some(
      (post) =>
        (!scheduledPostId || post.id === scheduledPostId) &&
        Boolean(post.publication?.publishNowRequestedAt) &&
        isInstagramPublicationPending(post.publication),
    ),
  );
